module.exports = __webpack_public_path__ + "static/media/Baslik.f75a93a7.png";